import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row gap-2 items-center md:items-start justify-between mb-6" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Your Loan Calculations ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_StartLoanButton = _resolveComponent("StartLoanButton")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_Heading, { class: "text-center md:text-left" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_StartLoanButton, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('newLoan')))
    })
  ]))
}